module.exports = __webpack_public_path__ + "img/bj19.ede922d1.png";